var exports = {
  "Gh": "BlockedUsersTab.module__userList___eWN0bH",
  "Kg": "BlockedUsersTab.module__userCard___eWN0bH",
  "eF": "BlockedUsersTab.module__userInfo___eWN0bH",
  "KI": "BlockedUsersTab.module__avatarButton___eWN0bH",
  "xO": "BlockedUsersTab.module__usernameButton___eWN0bH",
  "QV": "BlockedUsersTab.module__usernameContainer___eWN0bH",
  "Xh": "BlockedUsersTab.module__username___eWN0bH",
  "D2": "BlockedUsersTab.module__discriminator___eWN0bH",
  "o1": "BlockedUsersTab.module__actions___eWN0bH",
  "lK": "BlockedUsersTab.module__moreIcon___eWN0bH",
};

module.exports = exports;
